import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import store from './store/store'

import { Interceptors } from './store/features/AxiosInterceptor/AxiosInterceptor'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

//Interceptador de responses do axios, pega todas as responses de requisição, retorna as que deram certo e trata as que apresentam erros.
Interceptors()

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)
